import classnames from "classnames";
import { Chevron } from "components/Chevron/Chevron";
import { SvgInline } from "components/SvgInline/SvgInline";
import { IconName } from "components/SvgInline/types";
import { Account } from "library/accounts/types";
import { Product } from "library/hooks/types";
import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { RequestStatusType } from "./getRequestStatus";
import styles from "./manage-account-content.module.scss";

interface Props {
  component?: typeof Link | "a" | "div";
  to: string;
  href?: string;
  className?: string;
  status?: RequestStatusType;
  icon?: IconName;
  children: ReactNode;
  target?: string;
  onClick: () => void;
  rel?: string;
  state?:
    | {
        account?: Account;
      }
    | (Account & {
        activeTab?: string;
        product?: Product;
      });
}
const AccordionLineItem: FC<Props> = ({
  component: Tag = Link,
  status,
  children,
  icon,
  ...rest
}) => {
  const className = classnames(
    styles.lineItem,
    status ? styles.lineItemWithStatus : "",
    rest.className,
  );

  const props = { ...rest, className, href: rest.to };

  return (
    <Tag {...props}>
      {icon && <SvgInline name={icon} className={styles.icon} />}
      <span className={styles.lineItemContent}>
        <span>{children}</span>
        {status && <span className={styles.lineItemStatus}>{status}</span>}
      </span>
      {Tag !== "div" && (
        <Chevron direction="right" className={styles.chevron} />
      )}
    </Tag>
  );
};

export { AccordionLineItem };
